import React, { useEffect } from 'react';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from "react-router-dom"

export default function Redirect() {

    useEffect(() => {
        setTimeout(() => {
            window.location.href = `https://onelink.to/h4353w`;
            return;
        }, 5000);

    }, []);

    const openURL = async () => {
        const url = `https://onelink.to/h4353w`;
        try {
            window.location.href = url;
        } catch (error) {
            console.log("Error", error)
        }
    }

    return (
        <div className="bg-[#161616] py-10 w-full min-w-screen h-full min-h-screen items-center justify-center flex flex-col font-sans text-white">
            <p className='text-[3rem]'>Redirecting...</p>
            <p>If you do not wish to wait, <button onClick={openURL} className='underline underline-offset-4 hover:text-[#ceae7b]'> Click Here.</button></p>
        </div>
    );
}